export default "__VITE_ASSET__BfF7dJCv__"